import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "d-flex align-center px-2 py-1" }
const _hoisted_2 = {
  key: 0,
  class: "mx-0 my-2 pa-0"
}
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = { class: "mr-2" }
const _hoisted_5 = { class: "text-caption param-type-text" }
const _hoisted_6 = { class: "text-body-2 ml-2" }
const _hoisted_7 = { class: "d-flex align-center" }
const _hoisted_8 = { class: "mr-2" }
const _hoisted_9 = { class: "text-caption param-type-text" }
const _hoisted_10 = { class: "text-body-2 ml-2" }
const _hoisted_11 = { class: "code-block" }
const _hoisted_12 = {
  key: 1,
  class: "ml-1"
}
const _hoisted_13 = { class: "d-flex flex-wrap ga-2 mt-3" }
const _hoisted_14 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_15 = {
  key: 3,
  class: "mt-3"
}
const _hoisted_16 = { class: "text-caption mb-1" }
const _hoisted_17 = {
  key: 1,
  class: "response-block"
}
const _hoisted_18 = {
  key: 2,
  class: "code-block response-block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_vue_json_pretty = _resolveComponent("vue-json-pretty")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "mb-4 pa-2 card",
    color: "surface",
    variant: "elevated",
    elevation: "4",
    density: "compact"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_card_title, { class: "max-85 pr-0 py-1" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.name), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_btn, {
          color: "primary",
          class: "ml-auto",
          icon: _ctx.show ? 'mdi-chevron-up' : 'mdi-chevron-down',
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleShow(!_ctx.show))),
          density: "compact"
        }, null, 8, ["icon"])
      ]),
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_v_divider)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_form, {
        class: "ma-0 pa-0",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
        density: "compact"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_expand_transition, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_v_list, {
                class: "ma-0 pa-0",
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 tool-execution-item' : 'ma-0 pa-0 tool-execution-item'),
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.showGlobalTooltips)
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 0,
                            location: "top",
                            "max-width": "300",
                            text: "Description of what this tool does."
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_icon, _mergeProps(props, {
                                size: "x-small",
                                color: "warning",
                                class: "global-tooltip-icon mt-5 ml-n6"
                              }), {
                                default: _withCtx(() => _cache[3] || (_cache[3] = [
                                  _createTextVNode("mdi-information-outline")
                                ])),
                                _: 2,
                                __: [3]
                              }, 1040)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_textarea, {
                        modelValue: _ctx.description,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description) = $event)),
                        readonly: "",
                        label: "Description",
                        class: "pt-2",
                        variant: "outlined",
                        density: "compact",
                        "auto-grow": "",
                        rows: "2",
                        "row-height": "20"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  (_ctx.requiredParams.length > 0)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 0,
                        class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                        density: "compact"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.showGlobalTooltips)
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 0,
                                location: "top",
                                "max-width": "300",
                                text: "Parameters that must be provided when using this tool."
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_icon, _mergeProps(props, {
                                    size: "x-small",
                                    color: "warning",
                                    class: "global-tooltip-icon mt-5 ml-n6"
                                  }), {
                                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                                      _createTextVNode("mdi-information-outline")
                                    ])),
                                    _: 2,
                                    __: [4]
                                  }, 1040)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_expansion_panels, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel, {
                                title: "Required Parameters",
                                density: "compact"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel_text, null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requiredParams, (param) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: param.name,
                                          class: "mb-2"
                                        }, [
                                          _createElementVNode("div", _hoisted_3, [
                                            _createElementVNode("strong", _hoisted_4, _toDisplayString(param.name), 1),
                                            _createVNode(_component_v_chip, {
                                              size: "x-small",
                                              class: "mr-2 param-type-chip param-required-chip"
                                            }, {
                                              default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                _createTextVNode("Required")
                                              ])),
                                              _: 1,
                                              __: [5]
                                            }),
                                            _createElementVNode("span", _hoisted_5, _toDisplayString(param.type), 1)
                                          ]),
                                          _createElementVNode("p", _hoisted_6, _toDisplayString(param.description), 1)
                                        ]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.optionalParams.length > 0)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 1,
                        class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                        density: "compact"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.showGlobalTooltips)
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 0,
                                location: "top",
                                "max-width": "300",
                                text: "Parameters that can optionally be provided when using this tool."
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_icon, _mergeProps(props, {
                                    size: "x-small",
                                    color: "warning",
                                    class: "global-tooltip-icon mt-5 ml-n6"
                                  }), {
                                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                                      _createTextVNode("mdi-information-outline")
                                    ])),
                                    _: 2,
                                    __: [6]
                                  }, 1040)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_expansion_panels, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel, {
                                title: "Optional Parameters",
                                density: "compact"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel_text, null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionalParams, (param) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: param.name,
                                          class: "mb-2"
                                        }, [
                                          _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("strong", _hoisted_8, _toDisplayString(param.name), 1),
                                            _createVNode(_component_v_chip, {
                                              size: "x-small",
                                              class: "mr-2 param-type-chip param-optional-chip"
                                            }, {
                                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                _createTextVNode("Optional")
                                              ])),
                                              _: 1,
                                              __: [7]
                                            }),
                                            _createElementVNode("span", _hoisted_9, _toDisplayString(param.type), 1)
                                          ]),
                                          _createElementVNode("p", _hoisted_10, _toDisplayString(param.description), 1)
                                        ]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.example)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 2,
                        class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                        density: "compact"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.showGlobalTooltips)
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 0,
                                location: "top",
                                "max-width": "300",
                                text: "Example of how to use this tool."
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_icon, _mergeProps(props, {
                                    size: "x-small",
                                    color: "warning",
                                    class: "global-tooltip-icon mt-5 ml-n6"
                                  }), {
                                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                                      _createTextVNode("mdi-information-outline")
                                    ])),
                                    _: 2,
                                    __: [8]
                                  }, 1040)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_expansion_panels, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel, {
                                title: "Usage Example",
                                density: "compact"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel_text, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("pre", _hoisted_11, _toDisplayString(_ctx.example), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_list_item, {
                    class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_divider, { class: "my-2" }),
                      (!_ctx.serverEnabled)
                        ? (_openBlock(), _createBlock(_component_v_alert, {
                            key: 0,
                            type: "warning",
                            density: "compact",
                            variant: "tonal",
                            class: "mb-3"
                          }, {
                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                              _createTextVNode(" This server is disabled. Enable it to run this tool. ")
                            ])),
                            _: 1,
                            __: [9]
                          }))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parameters, (param) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `tool-param-${_ctx.toolId}-${param.name}`,
                          class: _normalizeClass(['param-input-row', { 'param-input-row-boolean': param.type === 'boolean' }])
                        }, [
                          (param.type === 'boolean')
                            ? (_openBlock(), _createBlock(_component_v_switch, {
                                key: 0,
                                modelValue: _ctx.argInputs[param.name],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.argInputs[param.name]) = $event),
                                label: `${param.name}${param.required ? ' *' : ''}`,
                                color: "primary",
                                "hide-details": !_ctx.fieldErrors[param.name],
                                density: "compact",
                                class: "tool-boolean-switch",
                                "error-messages": _ctx.fieldErrors[param.name] ? [_ctx.fieldErrors[param.name]] : []
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "hide-details", "error-messages"]))
                            : (param.type === 'number')
                              ? (_openBlock(), _createBlock(_component_v_text_field, {
                                  key: 1,
                                  modelValue: _ctx.argInputs[param.name],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.argInputs[param.name]) = $event),
                                  type: "number",
                                  label: `${param.name}${param.required ? ' *' : ''}`,
                                  variant: "outlined",
                                  density: "compact",
                                  "error-messages": _ctx.fieldErrors[param.name] ? [_ctx.fieldErrors[param.name]] : []
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "error-messages"]))
                              : (param.type === 'object' || param.type === 'array')
                                ? (_openBlock(), _createBlock(_component_v_textarea, {
                                    key: 2,
                                    modelValue: _ctx.argInputs[param.name],
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.argInputs[param.name]) = $event),
                                    label: `${param.name}${param.required ? ' *' : ''}`,
                                    variant: "outlined",
                                    density: "compact",
                                    "auto-grow": "",
                                    rows: "2",
                                    "error-messages": _ctx.fieldErrors[param.name] ? [_ctx.fieldErrors[param.name]] : []
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "error-messages"]))
                                : (_openBlock(), _createBlock(_component_v_text_field, {
                                    key: 3,
                                    modelValue: _ctx.argInputs[param.name],
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.argInputs[param.name]) = $event),
                                    label: `${param.name}${param.required ? ' *' : ''}`,
                                    variant: "outlined",
                                    density: "compact",
                                    "error-messages": _ctx.fieldErrors[param.name] ? [_ctx.fieldErrors[param.name]] : []
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "error-messages"])),
                          (param.description)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 4,
                                class: _normalizeClass([
                  'param-description',
                  { 'param-description-warning': _ctx.parameterDescriptionIsWarning(param.description) }
                ])
                              }, [
                                (_ctx.parameterDescriptionIsWarning(param.description))
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      size: "x-small",
                                      color: "warning",
                                      class: "mr-1"
                                    }, {
                                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                                        _createTextVNode("mdi-alert-outline")
                                      ])),
                                      _: 1,
                                      __: [10]
                                    }))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", null, _toDisplayString(param.description), 1),
                                (param.type === 'object' || param.type === 'array')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "(expects JSON " + _toDisplayString(param.type) + ")", 1))
                                  : _createCommentVNode("", true)
                              ], 2))
                            : _createCommentVNode("", true)
                        ], 2))
                      }), 128)),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          loading: _ctx.runLoading,
                          disabled: !_ctx.serverEnabled || _ctx.runLoading,
                          onClick: _ctx.runTool
                        }, {
                          default: _withCtx(() => _cache[11] || (_cache[11] = [
                            _createTextVNode(" Run Tool ")
                          ])),
                          _: 1,
                          __: [11]
                        }, 8, ["loading", "disabled", "onClick"]),
                        (_ctx.runResult !== null && _ctx.runResult !== undefined)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              variant: "outlined",
                              color: "secondary",
                              onClick: _ctx.copyResultPreview
                            }, {
                              default: _withCtx(() => _cache[12] || (_cache[12] = [
                                _createTextVNode(" Copy Preview ")
                              ])),
                              _: 1,
                              __: [12]
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (_ctx.runResult !== null && _ctx.runResult !== undefined)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 1,
                              variant: "outlined",
                              color: "secondary",
                              onClick: _ctx.downloadResult
                            }, {
                              default: _withCtx(() => _cache[13] || (_cache[13] = [
                                _createTextVNode(" Download Full Result ")
                              ])),
                              _: 1,
                              __: [13]
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.hasFieldErrors)
                        ? (_openBlock(), _createBlock(_component_v_alert, {
                            key: 1,
                            type: "error",
                            class: "mt-2",
                            density: "compact",
                            variant: "tonal"
                          }, {
                            default: _withCtx(() => _cache[14] || (_cache[14] = [
                              _createTextVNode(" Fix highlighted parameter errors before running this tool. ")
                            ])),
                            _: 1,
                            __: [14]
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.runError)
                        ? (_openBlock(), _createBlock(_component_v_alert, {
                            key: 2,
                            type: "error",
                            class: "mt-3",
                            density: "compact",
                            variant: "tonal"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.runError) + " ", 1),
                              (_ctx.showReconnectAction)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createVNode(_component_v_btn, {
                                      size: "small",
                                      color: "primary",
                                      variant: "outlined",
                                      onClick: _ctx.requestReconnect
                                    }, {
                                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                                        _createTextVNode(" Reconnect OAuth ")
                                      ])),
                                      _: 1,
                                      __: [15]
                                    }, 8, ["onClick"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.runResult !== null && _ctx.runResult !== undefined)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, " Response size: " + _toDisplayString(_ctx.responseSizeBytes) + " bytes ", 1),
                            (_ctx.isLargeResponse)
                              ? (_openBlock(), _createBlock(_component_v_alert, {
                                  key: 0,
                                  type: "info",
                                  density: "compact",
                                  variant: "tonal",
                                  class: "mb-2"
                                }, {
                                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                                    _createTextVNode(" Showing preview only. Download full response. ")
                                  ])),
                                  _: 1,
                                  __: [16]
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.parsedResponseJson.isJson)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _createVNode(_component_vue_json_pretty, {
                                    data: _ctx.parsedResponseJson.data,
                                    deep: 3,
                                    theme: "dark"
                                  }, null, 8, ["data"])
                                ]))
                              : (_openBlock(), _createElementBlock("pre", _hoisted_18, _toDisplayString(_ctx.responsePreview), 1))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.show]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}